<template>
	<page style="background: #fff">
		<c-form ref="form">
			<c-form-item label="关联资产领用单" required>
				<c-select v-model="receiveOrderId" ref="orderSelect" name="receive_apply_id" async :disabled="!!source" :clear="false" @search="searchOrder" @change="orderHandle">
					<template #option="{data, selected}">
						<select-option
							:name="data.name"
							:info="[
								`领用数量：${data.data.receive_quantity}件 | ${data.data.create_date}`
							]"
							:selected="selected"
						></select-option>
					</template>
				</c-select>
				<info-card code="assetsReceiveOrder" :id="receiveOrderId"></info-card>
			</c-form-item>
			<c-form-item v-if="assetsList.length" label="归还资产明细" name="item_list" required>
				<detail-card v-for="(item, i) in assetsList" :key="i" :index="i + 1">
					<template #title>
						<p>{{item.asset_name}}</p>
					</template>
					<c-field label="资产分类">{{item.asset_category || '-'}}</c-field>
					<template #form>
						<detail-card-form label="归还数量" required>
							<c-input value="1" type="number" name="return_quantity" :range="[1, Infinity]" disabled :append-text="item.unit_name"></c-input>
						</detail-card-form>
						<detail-card-form label="上传附件" required>
							<c-upload-file v-model="item.voucher_image_url" name="voucher_image_url" media multiple="9" type="image,video" :side="false" @click="takePhoto"></c-upload-file>
						</detail-card-form>
					</template>
				</detail-card>
			</c-form-item>
			<c-form-item label="归还时间" required>
				<c-datetime type="datetime" name="return_time" time-accuracy="min" format="yyyy-MM-dd hh:mm"></c-datetime>
			</c-form-item>
			<c-form-item label="备注">
				<c-input type="textarea" name="remark"></c-input>
			</c-form-item>
		</c-form>

		<template #button>
			<c-button size="form" @click="submitHandle(-1)">暂存</c-button>
			<c-button size="form" color="main" @click="submitHandle(1)">确认提交</c-button>
		</template>
	</page>
</template>

<script>
	export default {
		props: {
			id: String,
			source: String
		},

		data() {
			return {
				receiveOrderId: '',
				assetsList: []
			}
		},

		mounted() {
			if (this.id) {
				this.request({
					url: '/asset_return_apply/detail',
					data: {
						id: this.id
					},
					success: data => {
						this.$refs.form.set(data);
						this.$refs.orderSelect.setValueData([{
							name: data.receive_apply_code,
							value: data.receive_apply_id
						}]);
						this.assetsList = data.item_list;
					}
				})
			} else if (this.source) {
				this.request({
					url: '/asset_receive_apply/detail',
					data: {
						id: this.source
					},
					success: data => {
						this.$refs.form.set({
							return_time: new Date().format('yyyy-MM-dd hh:mm')
						});
						this.$refs.orderSelect.setValueData([{
							name: data.apply_code,
							value: data.id
						}]);
						this.orderHandle(data.id);
					}
				});
			} else {
				this.$refs.form.set({
					return_time: new Date().format('yyyy-MM-dd hh:mm')
				});
			}
		},

		methods: {
			searchOrder(keyword, resolve) {
				this.request({
					url: '/system/options',
					data: {
						options_code: 'ASSET_RECEIVE_APPLY',
						keyword: keyword
					},
					success: data => {
						resolve(data.map(item => {
							return {
								name: `${item.data.apply_code} | ${item.data.apply_title}`,
								value: item.data.id,
								data: item.data
							}
						}));
					}
				})
			},

			orderHandle(data) {
				if (data.value) {
					this.request({
						url: '/asset_receive_apply/detail',
						data: {
							id: data.value
						},
						success: data => {
							data.item_list.forEach(item => item.voucher_image_url = '');
							this.assetsList = data.item_list;
						}
					});
				} else {
					this.assetsList = [];
				}
			},

			submitHandle(state) {
				this.$refs.form.submit({
					url: this.id ? '/asset_return_apply/edit' : '/asset_return_apply/add',
					rule: {
						receive_apply_id: '请选择关联资产领用单',
						item_list: () => {
							if (this.assetsList.find(item => !item.voucher_image_url.length)) {
								return '请完善归还资产明细';
							}
							return true;
						},
						return_time: '请选择归还时间'
					},
					dataFormatter: data => {
						data.id = this.id;
						data.apply_status = state;
						data.item_list = this.assetsList.map(item => {
							return {
								receive_item_id: item.id,
								asset_id: item.asset_id,
								return_quantity: 1,
								voucher_image_url: item.voucher_image_url.join(',')
							}
						});
						return data;
					},
					success: (data, res) => {
						this.$message({
							message: '提交成功',
							mask: true
						});
						setTimeout(() => {
							if (this.id) {
								this.mp.navigateBack();
							} else {
								this.mp.redirectWeb('/assets/return/detail', {id: res.apply_id});
							}
						}, 1000);
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>